import React from 'react';
import './scout-mascot.css';

export type ScoutMood = 'idle' | 'working' | 'happy';

export interface ScoutMascotProps {
  /** idle: a slow breath; working: the segments crawl in a wave; happy: one hop (an answer arrived). */
  mood?: ScoutMood;
  /** Rendered width in px; the height follows. */
  size?: number;
  /** Translated name when Scout stands alone ("Scout"); omit when a visible label already names it. */
  label?: string;
  className?: string;
}

/**
 * Scout, the caterpillar from the JobCrawls logo (same shapes and colours, without the magnifier):
 * the face of the AI helpers across the Plus tools. Pure SVG with CSS motion from
 * scout-mascot.css; no inline <style>, so server and client markup match.
 */
export function ScoutMascot({ mood = 'idle', size = 40, label, className }: ScoutMascotProps) {
  return (
    <svg
      viewBox="4 1 80 44"
      width={size}
      height={Math.round((size * 44) / 80)}
      className={`jc-scout${className ? ` ${className}` : ''}`}
      data-mood={mood}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <g className="jc-scout-body">
        <circle className="jc-scout-seg jc-scout-seg-1" cx="14" cy="36" r="7.5" fill="#6F9142" />
        <circle className="jc-scout-seg jc-scout-seg-2" cx="23" cy="27" r="8.5" fill="#79994F" />
        <circle className="jc-scout-seg jc-scout-seg-3" cx="35" cy="21" r="9" fill="#79994F" />
        <circle className="jc-scout-seg jc-scout-seg-4" cx="48" cy="20" r="9.2" fill="#83A557" />
        <g className="jc-scout-head">
          <circle cx="64" cy="26" r="12" fill="#8DB05F" />
          <ellipse cx="65" cy="17" rx="14" ry="3.6" fill="#C8952F" />
          <path d="M53 17 C53 7 58 3 65 3 C72 3 77 7 77 17 Z" fill="#C8952F" />
          <rect x="62.5" y="3" width="5" height="14" rx="2.5" fill="#B07F24" />
          <g className="jc-scout-eye">
            <circle cx="61" cy="27" r="3.2" fill="#2C2317" />
            <circle cx="59.8" cy="25.9" r="1.1" fill="#fff" />
          </g>
          <g className="jc-scout-eye">
            <circle cx="70" cy="26" r="3.2" fill="#2C2317" />
            <circle cx="68.8" cy="24.9" r="1.1" fill="#fff" />
          </g>
          <path d="M61 32 Q65.5 36 70 31" stroke="#2C2317" strokeWidth="2.1" strokeLinecap="round" fill="none" />
        </g>
      </g>
    </svg>
  );
}
